import React from "react";
import PropTypes from "prop-types";
import css from "../../css/listing/header.module.css";
import { format, parseISO } from "date-fns";

class HeaderArchive extends React.PureComponent {
    render() {
        const { listing } = this.props;

        const listedDate = format(
            parseISO(listing.last_updated_date),
            "MMM do, yyyy"
        );

        return (
            <div className={css.header}>
                <div className={css.wrapper}>
                    <div className={css.address}>
                        <h1>
                            {listing.address} {listing.unit_number || ""}
                            <span>
                                {listing.city.name}, {listing.state.abbr}{" "}
                                {listing.zip.code}
                            </span>
                        </h1>
                    </div>
                    <div className={css.params}>
                        <div className={css.param}>
                            <div className={css.paramTitle}>Price</div>
                            <div className={css.paramValue}>Not For Sale</div>
                        </div>
                        <div className={css.param}>
                            <div className={css.paramTitle}>Last Update</div>
                            <div className={css.paramValue}>{listedDate}</div>
                        </div>
                        <div className={css.param}>
                            <div className={css.paramTitle}>Type</div>
                            <div className={css.paramValue}>Off Market</div>
                        </div>
                        <div className={css.param}>
                            <div className={css.paramTitle}>Status</div>
                            <div className={css.paramValue}>
                                <span className={css.badgeArchive}>
                                    Off Market
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HeaderArchive.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default HeaderArchive;
